import styled from '@emotion/styled/macro';

export const ActionPanel = styled.div(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
}));

export const ButtonContent = styled.div(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: 5,
  marginLeft: -4,
}));

export const ButtonLabel = styled.span(() => ({
  color: 'inherit',
}));

export const InfoMessage = styled.div((props) => ({
  padding: 20,
  fontSize: 13,
  fontFamily: props.theme.fonts.primary,
  color: props.theme.colors.inactive,
}));

export const EmptyState = styled.div((props) => ({
  padding: 20,
  textAlign: 'center',
  fontSize: 13,
  fontFamily: props.theme.fonts.primary,
  color: props.theme.colors.inactive,
}));
